import React from 'react';
import "../../css/parent-review.css";
import ParentImg1 from "../../assets/images/parentPage-reviewers/reviewer-1.png";
import { ReactComponent as QuoteLeft } from "../../assets/icons/quote-left.svg";
import { ReactComponent as QuoteRight } from "../../assets/icons/quote-right.svg";

const ParentReview = () => {
  return (
    <section id="parent-review">
      <div id="review-cont">
        <div className="pp-review">
          <img src={ParentImg1} alt="" />
          <div>
            <article>
              <QuoteLeft className="pp-quote-icon" id="quote-left" />
              <QuoteRight className="pp-quote-icon" id="quote-right" />
              <blockquote>
                The best solution for anyone who wants to work a flexible
                schedule but still earn
                <br id="pp-sect3-br" /> a full-time income.
              </blockquote>
              <div>
                <h3>Darren Dunlap</h3>
                <h4>CEO &amp; Founder at Flex.co</h4>
              </div>
            </article>
          </div>
        </div>
        <div id="slide-track">
          <span></span>
          <span className="pp-active-slide"></span>
          <span></span>
        </div>
      </div>
    </section>
  );
};

export default ParentReview;